import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement, useEffect } from 'react';
import { ICurrentWorkspaceStore } from '../../workspaces/currentWorkspace/CurrentWorkspace.store';
import { useCloudCostsService } from '../cloudCosts.service';
import { ICloudCostsStore } from '../cloudCosts.store';
import { CloudCostsHeader } from '../components/CloudCostsHeader';

export const CloudCostsHeaderContainer = observer((): ReactElement => {
  const store = useInjection(ICloudCostsStore.$);
  const cloudCostsService = useCloudCostsService();
  const currentWorkspaceStore = useInjection(ICurrentWorkspaceStore.$);

  const refreshAsync = async (): Promise<void> => {
    await cloudCostsService.getCloudCostsUsageAsync(currentWorkspaceStore.currentWorkspace.id);
  };

  useEffect(() => {
    void refreshAsync();
  }, [currentWorkspaceStore.currentWorkspace.id]);

  return <CloudCostsHeader usage={store.costsUsage} />;
});
